import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut, getAuthUser } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { PERSIST_STORE_NAME, REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import deepParseJson from 'utils/deepParseJson'

function useAuth() {

	const dispatch = useDispatch()

	const navigate = useNavigate()

	const query = useQuery()

	const { token, signedIn } = useSelector((state) => state.auth.session)

	const signIn = async ({ email, password }) => {
		try {
			const resp = await apiSignIn({ email, password })
			if (resp.data) {
				const { token, user } = resp.data
				dispatch(onSignInSuccess(token))
				if(user) {
					dispatch(setUser({
						email: user.email,
						avatar: '', 
						userName: `${user.first_name} ${user.last_name}`, 
						role: user.role?.role, 
						authority: user.role?.scopes?.map((e) => e.scope), 
					} || initialState))
				}
				const redirectUrl = query.get(REDIRECT_URL_KEY)
				navigate(redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath)
				return {
					status: 'success',
					message: ''
				}
			}
		} catch (errors) {
			return {
				status: 'failed',
				message: errors?.response?.data?.message || errors.toString()
			}
		}
	}

	const isAuthenticated = async()  => {
		try {
			const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
			const persistData = deepParseJson(rawPersistData)
			
			const accessToken = persistData.auth.session.token;
			if(!accessToken) return false
			const { data } = await getAuthUser();
			dispatch(setUser(data?.id ? { 
				email: data.email,
				avatar: '', 
				userName: `${data.first_name} ${data.last_name}`, 
				role: data.role?.role, 
				authority: data.role?.scopes?.map((e) => e.scope),
			} : initialState));
			if(data?.id) return true;
			return false;
		} catch (error) {
			dispatch(onSignOutSuccess())
			dispatch(setUser(initialState))
			console.error(error);
			return false;
		}
	}

	const handleSignOut = ()  => {
		dispatch(onSignOutSuccess())
		dispatch(setUser(initialState))
		navigate(appConfig.unAuthenticatedEntryPath)
	}

	const signOut = async () => {
		try {
			await apiSignOut()
			handleSignOut()
		} catch (errors) {
			handleSignOut()
		}
	}
    
	return {
		isAuthenticated,
		authenticated: token && signedIn,
		signIn,
		signOut
	}
}

export default useAuth